import { DataBean } from "../DataBean";


export class SystemPropertyOB extends DataBean {

    public async getSystemProperty(name: string): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.bean.account.SystemProperty_getSystemProperty_String", [name]);
    }
    
    public async getSystemPropertyByAppName(name: string): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getSystemPropertyCatalog_String", [name]);
    }

    public async getPrinterPropertiesZPL(idEmployee: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.Map_getPrinterPropertiesZPL_Number", [idEmployee]);
    }

}